import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


const API_URI = process.env.REACT_APP_API_URI || 'http://localhost:5000';
const CloudUrl = process.env.REACT_APP_CLOUD_FLARE_URL;

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [visiblePosts, setVisiblePosts] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const authHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};

    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API_URI}/api/blogs`, { headers: authHeaders });

        const blogsData = response.data.map(blog => ({
          id: blog._id,
          title: blog.title,
          description: blog.description,
          imageUrl: blog.images && blog.images.length
            ? `${CloudUrl}/${blog.images[0]}`
            : '',
          link: `/blog/${blog._id}`,
        }));

        setBlogs(blogsData);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setError('Failed to fetch blogs. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [token]);

  const handleShowMorePosts = () => {
    setVisiblePosts(prevVisiblePosts => prevVisiblePosts + 10);
  };

  if (loading) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex items-center justify-center">
        <p className="text-xl">Loading blogs...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex flex-col items-center justify-center">
        <p className="text-xl mb-4">{error}</p>
        <button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }

  const visibleBlogs = blogs.slice(0, visiblePosts);

  return (
    <div className="bg-black text-white p-8 min-h-screen">
      <h1 className="text-5xl md:text-6xl font-bold mb-8 text-center">Blog</h1>

      {blogs.length === 0 ? (
        <div className="text-center text-xl">
          <p>No blog posts available at the moment. Please check back later!</p>
        </div>
      ) : (
        <>
          <div className="space-y-8">
            {visibleBlogs.map(blog => (
              <div key={blog.id} className="flex flex-col md:flex-row items-center">
                <Link to={blog.link} className="w-full md:w-1/3 group">
                  <div className="relative overflow-hidden w-full h-64 mb-4 md:mb-0">
                    {blog.imageUrl ? (
                      <img
                        src={blog.imageUrl}
                        alt={blog.title}
                        className="absolute inset-0 w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                      />
                    ) : (
                      <div className="absolute inset-0 bg-gray-800 flex items-center justify-center">
                        <span className="text-gray-500">No Image Available</span>
                      </div>
                    )}
                  </div>
                </Link>
                <div className="md:w-2/3 p-4">
                  <Link to={blog.link}>
                    <h2 className="text-3xl md:text-4xl font-bold hover:text-green-500 transition-all duration-700 hover:underline">
                      {blog.title}
                    </h2>
                  </Link>
                  <Link to={blog.link}>
                    <p className="mt-2 text-lg md:text-xl hover:text-green-500 transition-all duration-700 hover:underline">
                      {blog.description}
                    </p>
                  </Link>
                  <Link to={blog.link} className="text-green-500 hover:underline transition-all duration-700 mt-4 inline-block">
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {visiblePosts < blogs.length && (
            <div className="text-center mt-8">
              <button
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
                onClick={handleShowMorePosts}
              >
                Show More Posts
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Blog;

